import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BikeService } from '../../services/bike.service';

@Component({
  selector: 'my-bike',
  template: require('./bike.component.html'),
  styles: [require('./bike.component.scss')]
})

export class BikeComponent implements OnInit{

  public customerList: any = [{'test': 'test'}];
  public bike:any = {
    'brand' : '',
    'model' : ''
  };

  constructor(private route:ActivatedRoute, private router:Router, private bikeService:BikeService) {

  }

  ngOnInit(): void {
    this.route.params.subscribe(params=> {
      if (params['privateId']) {
        this.bikeService.LoadClientFromBike(this.customerList, this.bike, params['privateId']);
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  openCustomer(privateId:string){
    this.router.navigate(['/customer', privateId]);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/bike/bike.component.ts